import { CHANGE_THEME } from '../actions/actions';

const initialState = {
    path: 'themes/theme-i.css'
}

const themesReducer = (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_THEME:
            return {
                ...state,
                path: action.path
            }
        default:
            return {
                ...state,
                path: 'themes/theme-i.css'
            }
    }
}

export default themesReducer;
